Directives.FileCommentDirective = function FileCommentDirective() {

    // @ngInject
    function FileCommentDirectiveControllerFunc($filter) {
    }

    var FileCommentDirectiveController = Class(Controllers.BaseController, {
        constructor: FileCommentDirectiveControllerFunc
    });

    return {
        scope: {
            comment: '=comment',
            currentUser: '=currentUser',
            commenter: '=commenter'
        },
        templateUrl: 'angular/app/modules/core/features/workspace_file/file_comments/file_comment_directive_template.html',
        controller: FileCommentDirectiveController,
        controllerAs: 'fileCommentVm',
        bindToController: true
    };
};